import bookings from './booking_form/bookings';
import lazyLoadBookingModal from './booking_form/lazy_load_booking_modal';

export default angular.module('common', [])
  .factory('bookings', bookings)
  .factory('lazyLoadBookingModal', lazyLoadBookingModal)
  .name;



// WEBPACK FOOTER //
// ./app/src/common/index.js